import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Dropdown from "../Steppers/Dropdown";
import removeIcon from "../../../../assets/svg/removeVarient.svg";
import StoreStepperContext from "../../../../context/storeStepperContext";
import ConfirmationModal from "../../../../components/common/ConfirmationModal/ConfirmationModal";

function AddVariant({ onAddVariant, clearVariant, copyItemFromSuggestion }) {
  const { storeformData, checkForEdit, productIdForEdit } =
    useContext(StoreStepperContext);
  const [variants, setVariants] = useState([]);
  const [currentVariant, setCurrentVariant] = useState({
    variantId: "",
    variantName: "",
    variantValue: [],
  });
  const [editVariantId, setEditVariantId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
    variantId: "",
  });
  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false, variantId: "" });
  };

  useEffect(() => {
    if ((checkForEdit === true && productIdForEdit) || copyItemFromSuggestion) {
      setVariants(storeformData?.currentProduct?.productVarient);
    }
  }, [
    checkForEdit,
    copyItemFromSuggestion,
    productIdForEdit,
    storeformData?.currentProduct?.productVarient,
  ]);

  const handleSaveVariant = () => {
    if (currentVariant.variantName && currentVariant.variantValue.length > 0) {
      if (editVariantId) {
        // Edit existing variant
        const updatedVariants = variants.map((variant) =>
          variant.variantId === editVariantId
            ? { ...variant, ...currentVariant }
            : variant
        );
        setVariants(updatedVariants);
        onAddVariant(updatedVariants);
        setEditVariantId(null); // Exit edit mode
      } else {
        // Add new variant
        const newVariant = {
          ...currentVariant,
          variantId: Date.now(),
        };
        const updatedVariants = [...variants, newVariant];
        setVariants(updatedVariants);
        onAddVariant(updatedVariants);
      }

      // Reset currentVariant and hide dropdown
      setCurrentVariant({ variantId: "", variantName: "", variantValue: [] });
      setShowDropdown(false);
    }
  };

  const handleEditVariant = (variantId) => {
    const variantToEdit = variants.find(
      (variant) => variant.variantId === variantId
    );
    if (variantToEdit) {
      setCurrentVariant(variantToEdit);
      setEditVariantId(variantId);
      setShowDropdown(true);
    }
  };

  const deleteHandler = async () => {
    const updatedVariants = variants.filter(
      (variant) => variant.variantId !== confirmatioModalState.variantId
    );
    setVariants(updatedVariants);
    onAddVariant(updatedVariants);
    setConfirmationModalState({ showModal: false, variantId: "" }); // Close confirmation modal
  };

  const handleRemoveVariant = (variantId) => {
    setConfirmationModalState((prev) => ({
      showModal: true,
      variantId: variantId,
    }));
    // const updatedVariants = variants.filter(
    //   (variant) => variant.variantId !== variantId
    // );
    // setVariants(updatedVariants);
    // onAddVariant(updatedVariants);
  };

  useEffect(() => {
    if (clearVariant) {
      setVariants([]);
      setCurrentVariant({
        variantId: "",
        variantName: "",
        variantValue: [],
      });
    }
  }, [clearVariant]);

  return (
    <Box>
      {variants?.length > 0 ? (
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px", marginTop: "24px" }}
        >
          Variant
        </Typography>
      ) : (
        <Box
          sx={{
            border: "1px solid #E5E5E8",
            padding: "16px",
            borderRadius: "8px",
            backgroundColor: "#F9FAFB",
            marginTop: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
              Add Variant
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                color: "rgba(28, 38, 48, 1)",
                marginTop: "4px",
              }}
            >
              Add up to 2 variants to help buyers choose the perfect product!
            </Typography>
          </Box>
          <Box>
            {!showDropdown && (
              <Button
                variant="outlined"
                sx={{
                  marginTop: "16px",
                  alignSelf: "flex-end",
                  border: "1px solid rgba(229, 229, 232, 1)",
                  color: "rgba(28, 38, 48, 1)",
                  ":hover": {
                    border: "1px solid rgba(229, 229, 232, 1)",
                    color: "rgba(28, 38, 48, 1)",
                  },
                }}
                onClick={() => setShowDropdown(true)}
              >
                Add Variant
              </Button>
            )}
          </Box>
        </Box>
      )}

      {variants?.map((variant, index) => (
        <Box
          key={variant.variantId}
          sx={{
            padding: "16px",
            border: "1px solid #E5E5E8",
            borderRadius: "8px",
            marginTop: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
              Variant {index + 1}
            </Typography>
            <Box>
              <img
                src={removeIcon}
                alt="remove"
                onClick={() => handleRemoveVariant(variant.variantId)}
                style={{
                  cursor: "pointer",
                }}
              />
            </Box>
          </Box>

          <Dropdown
            currentVariant={variant}
            onVariantChange={(name, value) =>
              setCurrentVariant((prev) => ({ ...prev, [name]: value }))
            }
          />
          {/* <Box sx={{ marginTop: "8px", display: "flex", gap: "16px" }}>
            <Button
              color="primary"
              onClick={() => handleEditVariant(variant.variantId)}
            >
              Edit
            </Button>
          </Box> */}
        </Box>
      ))}

      {showDropdown && (
        <Box
          sx={{
            marginTop: "16px",
            padding: "16px",
            border: "1px solid #E5E5E8",
            borderRadius: "8px",
          }}
        >
          <Dropdown
            currentVariant={currentVariant}
            onVariantChange={(name, value) =>
              setCurrentVariant((prev) => ({ ...prev, [name]: value }))
            }
          />
          <Button
            variant="contained"
            sx={{ marginTop: "16px" }}
            onClick={handleSaveVariant}
          >
            {editVariantId ? "Update Variant" : "Save Variant"}
          </Button>
        </Box>
      )}
      {variants?.length > 0 && (
        <Box>
          {!showDropdown && (
            <Button
              variant="outlined"
              sx={{
                marginTop: "16px",
                alignSelf: "flex-end",
                border: "1px solid rgba(229, 229, 232, 1)",
                color: "rgba(89, 31, 204, 1)",
                ":hover": {
                  border: "1px solid rgba(229, 229, 232, 1)",
                  color: "rgba(28, 38, 48, 1)",
                },
              }}
              onClick={() => setShowDropdown(true)}
            >
              Add Variant
            </Button>
          )}
        </Box>
      )}
      <ConfirmationModal
        showModal={confirmatioModalState.showModal}
        submitHandler={() => deleteHandler()}
        submitText={"Delete"}
        cancelText={"Cancel"}
        cancelHandler={cancelHandler}
        headerText={"Are you sure to delete this variant?"}
        bodyText={"This will change the variant Table"}
      />
    </Box>
  );
}

export default AddVariant;
